import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-copy-analyse-dialog',
  template: `
    <h2 mat-dialog-title>Analyse kopieren</h2>
    <mat-dialog-content>
      <form [formGroup]="form">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Name der neuen Analyse</mat-label>
          <input matInput formControlName="name" required>
          <mat-error *ngIf="form.get('name').hasError('required')">
            Name ist erforderlich
          </mat-error>
        </mat-form-field>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Abbrechen</button>
      <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="onSubmit()">
        Kopieren
      </button>
    </mat-dialog-actions>
  `
})
export class CopyAnalyseDialogComponent {
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<CopyAnalyseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      name: [data.name, Validators.required]
    });
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.get('name').value);
    }
  }
} 